import { NgModule } from '@angular/core';
import { SharedModule } from '../common/shared.module';
import { HomeComponent } from './home.component';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';


@NgModule({
	imports: [
		CommonModule,
		SharedModule,
		RouterModule
	],
	declarations: [HomeComponent],
})
export class HomeModule {
}



// WEBPACK FOOTER //
// /Users/sofia/Documents/ng2-portals/ng2-firebase-toolkit-admin/src/app/home/home.module.ts